// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__gJ60S","btnSm":"Button_btnSm__2ce4M","btnBlock":"Button_btnBlock__mNmdy","secondary":"Button_secondary__3vQRk","linkBtn":"Button_linkBtn__1q-LE"};